export namespace Assets {
  export namespace Plugin {
    export const Name = 'assets';
  }
}
